import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { PlycaUiScrollPanelComponent } from '../scroll-panel.component';

@Component({
  selector: 'plyca-ui-scroll-panel-demo',
  templateUrl: './scroll-panel-demo.component.html',
  styleUrls: ['./scroll-panel-demo.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [PlycaUiScrollPanelComponent]
})
export class PlycaUiScrollPanelDemoComponent {}
